<template>
  <div class="pos-layout">

    <!-- cartTop -->
    <div class="group">
      <label>{{$t('functions.cart_top')}}</label>
      <PosLayoutGrid v-model="value.cartTop" :functions="functions"/>
    </div>

    <!-- cartBot -->
    <div class="group">
      <label>{{$t('functions.cart_bottom')}}</label>
      <PosLayoutGrid v-model="value.cartBot" :functions="functions"/>
    </div>

    <!-- paymentBot -->
    <!--<div class="group">
      <label>PAYMENT BOT</label>
      <PosLayoutGrid v-model="value.paymentBot" :functions="functions"/>
    </div>-->

  </div>
</template>

<script>
import PosLayoutGrid from "@/components/qsr/PosLayoutGrid";

export default {
  name: "PosLayout",
  components: {PosLayoutGrid},
  props: {
    value: Object,
    functions: Array
  }
}
</script>

<style lang="scss" scoped>

</style>